/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Grid, FormGroup, FormControlLabel } from '@mui/material';
import MUICheckbox from '../MUICheckbox/MUICheckbox';

interface IMenuData {
    menuId: number;
    roleId: number;
    sortOrder: number;
    isDisplay: boolean;
    menuName: string;
    menuFeaturePermissions: MenuFeaturePermission[];
  }
  
interface MenuFeaturePermission {
    menuFeatureId: number;
    menuFeature: string;
    hasPermission: boolean;
  }

interface SelectedMenuId {
    menuFeatureId: number;
  }

interface PermissionTabContentProps {
    menuData: IMenuData;
    onItemSelect: (menuObj: SelectedMenuId, checked: boolean, menuType: string) => void;
    selected: boolean;
    selectAllChecked: boolean; // Add selectAllChecked prop to the interface
    selectedMenuFeatureIds: any;
}

function AddPermissionTabContent({ menuData, onItemSelect, selected, selectAllChecked, selectedMenuFeatureIds }: PermissionTabContentProps): JSX.Element {
    const [permissions, setPermissions] = useState<MenuFeaturePermission[]>(menuData.menuFeaturePermissions);
    const [mainMenuSelectStatus, setMainMenuSelectedStatus] = useState<string>("");

    useEffect(() => {
        setPermissions(menuData.menuFeaturePermissions);
    }, [menuData.menuFeaturePermissions]);

    useEffect(() => {
        const newPermissions = permissions.map(permission => ({
            ...permission,
            //@ts-ignore
            hasPermission: selectedMenuFeatureIds.includes(permission.menuFeatureId)
        }));
        const hasPermission = newPermissions.filter(data => data.hasPermission)
        if(hasPermission.length > 0) {
            setMainMenuSelectedStatus(newPermissions.length !== hasPermission.length ? "partial" : "all")
            
        } else {
            setMainMenuSelectedStatus("")
        }
        setPermissions(newPermissions);
    }, [selectAllChecked, selected]);

    const handleCheckboxChange = (menuFeatureId: number, checked: boolean, menuType: string): void => {
        const updatedPermissions = permissions.map(permission => {
            if (permission.menuFeatureId === menuFeatureId) {
                permission.hasPermission = checked
            }
            return permission;
        });

        const hasPermission = updatedPermissions.filter(data => data.hasPermission)
        if(hasPermission.length > 0) {
            setMainMenuSelectedStatus(updatedPermissions.length !== hasPermission.length ? "partial" : "all")
            updatedPermissions.length === hasPermission.length && onItemSelect({ menuFeatureId: menuData.menuId }, true, "main");
        } else {
            setMainMenuSelectedStatus("")
        }


        setPermissions(updatedPermissions);
        onItemSelect({ menuFeatureId }, checked, menuType);
    };

    return (
        <div>
            <Grid container spacing={0} alignItems="center" sx={{marginLeft: '2px'}}>
                <Grid item xs={11} sx={{ display: 'flex' }}>
                    <FormGroup sx={{ '& .MuiFormControlLabel-label': { fontWeight: 'bold' }}}>
                        <FormControlLabel control={<MUICheckbox checked={mainMenuSelectStatus === "all"} onChange={() => onItemSelect({ menuFeatureId: menuData.menuId }, !selected, "main")} indeterminate={mainMenuSelectStatus === "partial"} />} label={menuData.menuName} />
                    </FormGroup>
                </Grid>
            </Grid>
            <Grid container spacing={0} alignItems="center" sx={{paddingLeft: '25px'}}>
                <Grid item xs={11}>
                    {permissions.map(permission => (
                        <div key={permission.menuFeatureId} className="flex items-center mb-2">
                            <FormGroup>
                                <FormControlLabel control={<MUICheckbox  onChange={() => handleCheckboxChange(permission.menuFeatureId, !permission.hasPermission, "sub")} checked={permission.hasPermission} />} label={permission.menuFeature} />
                            </FormGroup>
                        </div>
                    ))}
                </Grid>
            </Grid>
            <hr style={{ border: 'none', borderBottom: '1px solid #e0e0e0', width: '100%', margin: '4px 0' }} />
        </div>
    );
}

export default AddPermissionTabContent;
